import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button, Form } from 'react-bootstrap';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import logo from '../assets/images/mobicom.png'
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { adminLogin } from '../api/context/auth';

export const SignIn = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState('login');
    const [showPassword, setShowPassword] = useState({
        password: false,
    });
    const [rememberMe, setRememberMe] = useState(false);


    const togglePasswordVisibility = (fieldName) => {
        setShowPassword(prev => ({ ...prev, [fieldName]: !prev[fieldName] }));
    };

    const forgotPass = () => {
        setForm("forgot")
    }


    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: Yup.object().shape({
            username: Yup.string().matches(/(\<|^)[\w\d._%+-]+@(?:[\w\d-]+\.)+(\w{2,})(\>|$)/, 'Enter a valid username')
                .required('Required'),
            password: Yup.string()
                .required('Required'),
        }),
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                username: values.username,
                password: values.password
            };
            adminLogin(payload)((response) => {
                if (response && response.status_code === 200) {
                    if (rememberMe) {
                        localStorage.setItem('rememberedEmail', values.username);
                        localStorage.setItem('rememberedPassword', values.password);
                    } else {
                        localStorage.removeItem('rememberedEmail');
                        localStorage.removeItem('rememberedPassword');
                    }
                    // const permissions = response?.data?.permissionCodes
                    localStorage.setItem('token', response?.data?.access_token);
                    localStorage.setItem('refresh_token', response?.data?.refresh_token);
                    // localStorage.setItem('permissions', JSON.stringify(permissions));
                    localStorage.setItem('user', JSON.stringify(response?.data?.user));
                    toast.success("Logged in successfully")
                    formik.resetForm();
                    setLoading(false);
                    navigate('/');
                }
                else {
                    console.log(response?.response?.data?.error_message, "error");
                    toast.error(response?.response?.data?.error_message);
                    setLoading(false);
                }
            });
        },
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, '');
        formik.setFieldValue(name, trimmedValue);
    };

    useEffect(() => {
        const rememberedEmail = localStorage.getItem('rememberedEmail');
        const rememberedPassword = localStorage.getItem('rememberedPassword');
        if (rememberedEmail && rememberedPassword) {
            // Populate form fields with stored credentials
            formik.setValues({
                username: rememberedEmail,
                password: rememberedPassword,
            });
            // Also set the "Remember me" checkbox as checked
            setRememberMe(true);
        }
    }, []);


    return (

        <div className='login-card'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='row'>
                            <div className='col-lg-6 p-0'>
                                <div className='left_wrapper'>
                                    <div className='img_wrapper'>
                                        <img src={logo} className='img-fluid logo_img' alt='Logo' />
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6 p-0'>
                                <div className='right_wrapper'>
                                    <div className='right_wrapper_bottom'>
                                        {form === 'login' && (
                                            <>
                                                <h3>Log In</h3>
                                                <Form className='login_form_wrapper' onSubmit={formik.handleSubmit}>
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder=""
                                                            name="username"
                                                            value={formik.values?.username}
                                                            onChange={handleInputChange}
                                                            isValid={formik.touched.username && !formik.errors.username}
                                                            isInvalid={formik.touched.username && !!formik.errors.username}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{formik.errors.username}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                        <Form.Label>Password</Form.Label>
                                                        <div className='eye_icon_wrapper'>
                                                            <Form.Control
                                                                type={showPassword.password ? 'text' : 'password'}
                                                                placeholder=""
                                                                name='password'
                                                                value={formik.values?.password}
                                                                onChange={handleInputChange}
                                                                isValid={formik.touched.password && !formik.errors.password}
                                                                isInvalid={formik.touched.password && !!formik.errors.password}
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.password}</Form.Control.Feedback>
                                                            {showPassword.password ? (
                                                                <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                            ) : (
                                                                <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("password")} />
                                                            )}
                                                        </div>

                                                    </Form.Group>
                                                    <div className='remember_forgot_wrapper'>
                                                        <Form.Group className="" controlId="formBasicCheckbox">
                                                            <span className="remember">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    aria-label="Remember Me"
                                                                    checked={rememberMe}
                                                                    onChange={(e) => setRememberMe(e.target.checked)}
                                                                />{' '}
                                                                Remember me
                                                            </span>
                                                        </Form.Group>
                                                        {/* <Button className='forgot_pass' onClick={() => forgotPass()}>Forgot Password?</Button> */}
                                                    </div>

                                                    <Button className='login_btn' type="submit" disabled={loading}>
                                                        {loading ? "Loading" : "Log In"}
                                                    </Button>
                                                </Form>
                                            </>
                                        )}

                                        {/* {form === 'forgot' && (
                                            <>
                                                <h3>Forgot Password</h3>
                                                <Form className='login_form_wrapper' >
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Email address</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder=""

                                                        />
                                                    </Form.Group>
                                                    <div className='remember_forgot_wrapper justify-content-end'>
                                                        <div className='forgot_pass' onClick={() => navigate(-1)}>Back to login</div>
                                                    </div>
                                                    <Button className='login_btn' type="submit" disabled={loading}>
                                                        {loading ? "Loading" : "Submit"}
                                                    </Button>
                                                </Form>
                                            </>
                                        )} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
